'use strict';

import * as util from '../util/Common.js';
import {EventManager} from '../util/EventManager.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {BoxContentControl} from '../content/BoxContent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';
import {TileView} from '../ui/TileView.js';
import {ContentViewSession} from '../viewer/ContentView.js';

const privateMap = util.createPrivateMapper();

export class ThumbnailView {
  constructor(argOptions){
    const pv = privateMap(this);

    pv.boxControl = new BoxContentControl();
    pv.control = {
      box: pv.boxControl
    };
    pv.renderTimeout = false;
    pv.size = new Point2D();

    pv.canvas = domUtil.createElement('canvas');
    pv.context2d = pv.canvas.getContext('2d');
    domUtil.asAbsoluteFit(pv.canvas);
    domUtil.noBoundary(pv.canvas);

    pv.render = () => {
      pv.renderTimeout = false;
      pv.canvas.width = pv.canvas.width
      if (pv.renderer && pv.resource) {
        pv.renderer.render(this, pv.resource, pv.control, pv.session);
      }
    }
  }

  get canvas(){
    return privateMap(this).canvas;
  }

  get context2d(){
    return privateMap(this).context2d;
  }

  get size(){
    return privateMap(this).size.clone();
  }
  set size(size){
    const pv = privateMap(this);
    pv.size.copy(size);
    pv.boxControl.viewSize = pv.size;
    pv.boxControl.fit();
    domUtil.canvasResize(pv.canvas, pv.size);
    this.requestRender();
  }
  renderImage(resource, renderer){
    const pv = privateMap(this);
    if (pv.session) {
      pv.session.destroy();
    }
    pv.session = null;
    pv.resource = resource;
    pv.renderer = renderer;
    pv.boxControl.viewSize = pv.size;
    if (resource) {
      pv.session = new ContentViewSession();
      pv.boxControl.boxSize = resource.size;
      pv.boxControl.fit();
    }
    this.requestRender();
  }

  get center(){
    return privateMap(this).size.div(2);
  }

  requestRender(){
    const pv = privateMap(this);
    if (pv.renderTimeout) {
      return;
    }
    pv.renderTimeout = requestAnimationFrame(pv.render);
  }
}

export class SequenceTileView extends TileView {
  constructor(domEl, options) {
    const initializeSceneTile = options.initializeSceneTile ? options.initializeSceneTile : function(){};
    const loadView = (tileObj, tileView) => {
      const pv = privateMap(this);
      return {
        _loaded: false,
        loaded: function(){
          return this._loaded;
        },
        load: function(){
          tileObj.domEl.addEventListener('click', function(ev){
            ev.preventDefault();
            ev.stopPropagation();
            pv.animationChange = pv.useAnimationOnTileClick;
            tileView.controller.sceneNo = tileObj.index;
          });
          const thumbnail = tileObj.view.thumbnail ? tileObj.view.thumbnail : tileObj.view;
          let thumbnailView;
          if (thumbnail) {
            const resourceLoader = pv.resourceLoaders[thumbnail.type];
            if (resourceLoader) {
              thumbnailView = new ThumbnailView();
              thumbnailView.size = tileView.gridSize;
              resourceLoader.load(thumbnail.source, (resource) => {
                const renderer = pv.renderers[resource.type];
                if (!renderer) {
                  return;
                }
                thumbnailView.renderImage(resource, renderer);
              });
            }
          }
          initializeSceneTile(tileObj, thumbnailView);
          this._loaded = true;
        }
      };
    }
    const tileViewOptions = Object.assign({}, options, {
      loadView: loadView
    });
    super(domEl, tileViewOptions);
    const pv = privateMap(this);
    pv.resourceLoaders = options.resourceLoaders ? options.resourceLoaders : {};
    pv.renderers = options.renderers ? options.renderers : {};
    pv.tileClickHandler = options.tileClickHandler;
    pv.animationChange = false
    pv.viewchangeListener = (ev) => {
      this.selectTiles(pv.controller.sceneNos, pv.animationChange);
      // this.selectTile(pv.controller.sceneNo, pv.animationChange);
      pv.animationChange = false;
    };
    pv.useAnimationOnTileClick = true;
  }

  get useAnimationOnTileClick(){
    return privateMap(this).useAnimationOnTileClick;
  }
  set useAnimationOnTileClick(useAnimationOnTileClick){
    privateMap(this).useAnimationOnTileClick = useAnimationOnTileClick;
  }

  get controller(){
    return privateMap(this).controller;
  }
  set controller(sequenceController){
    const pv = privateMap(this);
    if (pv.controller) {
      pv.controller.removeEventListener('viewchange', pv.vivewchangeListener);
    }
    this.clearTiles();
    pv.controller = sequenceController;
    if (!pv.controller) {
      return;
    }
    const tiles = [];
    this.reverseOrder = sequenceController.reverseOrder
    this.updateLayout()
    pv.controller.eachScene(function(scene){
      tiles.push(scene);
    })
    this.addTiles(tiles);
    pv.controller.addEventListener('viewchange', pv.viewchangeListener);
    if (pv.controller.sceneNos.length != 0) {
      this.selectTiles(pv.controller.sceneNos, false);
    }
  }
}